import { clearStudent } from "../actions/common/student";
import SettingNavi from "../components/features/Navigation/SettingNavi";
import { useNavigationToggle } from "../contexts/NavigationContext";
import { withRouter } from "../helpers/RouterHelper";
import {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../hocs/enhanceAuthenticatedPage";

export interface SidebarProps
  extends AuthenticatedPageProps,
    AuthenticatedPageCallbacks {
  clearStudent: typeof clearStudent;
  activeMenu: string;
}

const SectionSettingSidebar = (props: SidebarProps) => {
  const { isNavigationOpen } = useNavigationToggle();

  if (
    !props.currentSection.data ||
    !props.currentOperator ||
    !props.operatorPrivileges.data?.privileges
  ) {
    return null;
  }

  return (
    <SettingNavi
      {...props}
      privileges={props.operatorPrivileges.data?.privileges}
      section={props.currentSection.data}
      opened={isNavigationOpen}
    />
  );
};

export default withRouter<SidebarProps>(SectionSettingSidebar);
